import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { db } from "../firebaseConfig";
import { collection, onSnapshot } from "firebase/firestore";
import { SearchContext } from "../SearchContext";
import { FaHome } from "react-icons/fa";

const Navbar = () => {
	const navigate = useNavigate();
  const [menuList, setMenuList] = useState([]);
  const [visibleItems, setVisibleItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const navRef = useRef(null);
  const { searchText, setSearchText } = useContext(SearchContext);

  useEffect(() => {
    const handleScroll = () => {
      const logoSection = document.querySelector('.logo-section');
      const triggerHeight = logoSection ? logoSection.offsetHeight : 95;
      setIsFixed(window.scrollY > triggerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "categories"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMenuList(data.sort((a, b) => (a.order || 0) - (b.order || 0)));
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const containerWidth = navRef.current?.offsetWidth || 900;
    const itemWidth = 100;
    const maxVisible = Math.floor((containerWidth - 300) / itemWidth);
    setVisibleItems(menuList.slice(0, maxVisible));
  }, [menuList]);

  return (
    <>
      <nav ref={navRef} className={isFixed ? "navbar navbar-fixed" : "navbar"}>
        <div className="nav-left">
          <Link to="/" className="main-nav-link" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <FaHome size={18} /> সর্বশেষ
          </Link>
          {visibleItems.map((menu) => (
            <Link key={menu.id} to={`/category/${menu.name}`} className="main-nav-link">
              {menu.name}
            </Link>
          ))}
        </div>
        <div className="nav-right">
          <div className="hamburger" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>☰</div>
          <div className={`dropdown-menu ${isOpen ? "show" : ""}`} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            {menuList.map((menu) => (
              <Link key={menu.id} to={`/category/${menu.name}`} className="dropdown-category">
                {menu.name}
              </Link>
            ))}
          </div>
          <div className="search-box">
            <input type="text" placeholder="খুঁজুন..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
           <button
  className="search-btn"
 onClick={() => {
  if (searchText.trim()) {
    const keyword = searchText.trim();

    navigate(`/search?q=${encodeURIComponent(keyword)}`);

    setSearchText("");
  }
}}
>
  সার্চ
</button>
          </div>
        </div>
      </nav>
      {/* ফিক্সড হলে এই ডিভটি হাইট ধরে রাখবে */}
      {isFixed && <div style={{ height: "60px" }}></div>}
    </>
  );
};

export default Navbar;